import { render } from "./InventoryPanel.vue?vue&type=template&id=467fb777"
import script from "./InventoryPanel.vue?vue&type=script&lang=js"
export * from "./InventoryPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__